// extracted by mini-css-extract-plugin
export default {"amazonPayModeSection":"m5-z"};